import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  FlexDirection,
  FontWeight,
  JustifyContent,
  Text,
} from '@gousto-internal/citrus-react'

import { DiscountPerWeek } from './components/DiscountPerWeek'
import { Sections, trackCTAClick, TrackingActions } from '../../tracking'

export type DiscountBannerProps = {
  onBannerCTAClick: () => void
}

const onEnter =
  (callback: (event: React.KeyboardEvent) => void) => (event: React.KeyboardEvent) => {
    event.code === 'Enter' && callback(event)
  }

export function DiscountBanner({ onBannerCTAClick }: React.PropsWithChildren<DiscountBannerProps>) {
  const handleAndTrackBannerCTAClick = () => {
    onBannerCTAClick()
    trackCTAClick(TrackingActions.COMPREHENSION_GAP_BANNER_CTA, Sections.HERO)
  }

  return (
    <Box
      data-testid="discount-banner"
      display={Display.Flex}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.Center}
      bg={Color.ColdGrey_900}
      color={Color.White}
      onClick={handleAndTrackBannerCTAClick}
      onKeyDown={onEnter(handleAndTrackBannerCTAClick)}
      role="button"
      aria-label="Apply welcome offer discount"
      tabIndex={0}
      width={['min(380px, 92%)', '380px']}
      height={['130px', '138px']}
      style={{
        borderRadius: '8px',
        backgroundColor: 'rgba(33, 41, 48, 0.5)',
        backdropFilter: 'blur(16px)',
      }}
    >
      <Box
        display={Display.Flex}
        alignItems={AlignItems.Center}
        flexDirection={FlexDirection.Column}
        gap={2}
      >
        <Text fontWeight={FontWeight.Bold} size={2} color={Color.White}>
          Welcome offer<sup>**</sup>
        </Text>
        <DiscountPerWeek />
      </Box>
    </Box>
  )
}
